import { render, staticRenderFns } from "./LeaveApprovellist.vue?vue&type=template&id=a32f4800"
import script from "./LeaveApprovellist.vue?vue&type=script&lang=js"
export * from "./LeaveApprovellist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports